// utils/stringHelpers.js (you can put this in a global utils file)
export const FirstLetterCapital = (status = "") =>
  status
    .toLowerCase()
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
